export default class TemporaryDistance {
  targetDate: string;
  affiliationId: string;
  userIncode: string;
  distance: string;
  startTime: string;
  endTime: string;
  constructor(
    targetDate = "",
    affiliationId = "",
    userIncode = "",
    distance = "",
    startTime = "",
    endTime = ""
  ) {
    this.targetDate = targetDate;
    this.affiliationId = affiliationId;
    this.userIncode = userIncode;
    this.distance = distance;
    this.startTime = startTime;
    this.endTime = endTime;
  }
}
